import React from 'react';
import AppHeader from '../../common/app-header/AppHeader';
import { SubscriptionDetailsTab } from './components/tabs/SubscriptionDetailsTab';
import BasicTabs from '../../common/basic-tabs/BasicTabs';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import BizCoverBanner from '../../common/bizcover-banner';
import { NotificationsTab } from './components/tabs/NotificationsTab';
//import { useSearchParams } from 'react-router-dom';

const SettingsPage = () => {
  const { t } = useTranslation();
  //const [searchParams] = useSearchParams();
  //const tab = searchParams.get('tab');

  const tabs = [
    t('settings.titles.plan'),
    t('settings.titles.notifications') /*,t('headers.administration')*/,
  ];
  const tabContents = [
    <SubscriptionDetailsTab key={0} />,
    <NotificationsTab key={1} />,

    /*<>
      <NoCompanyRedirect>
        <ClerkOrganizationProfileTab key={1} />
      </NoCompanyRedirect>
    </>,*/
  ];

  return (
    <>
      <AppHeader title={t('headers.settings')} />
      <Box sx={{ marginTop: '16px', paddingBottom: '16px' }}>
        <BasicTabs tabs={tabs} tabContents={tabContents} activeTab={0} />
        <BizCoverBanner variant='wide' />
      </Box>
    </>
  );
};
export default SettingsPage;
